import { cl } from 'lincd/utils/ClassNames';
import * as React from 'react';
import style from './Spinner.module.css';

import { asset } from 'lincd/utils/LinkedFileStorage';

interface SpinnerProps {
  active?: boolean;
  centered?: boolean;
  color?: 'white' | 'grey' | 'blue';
  className?: string;
}
export function Spinner({
  active = true,
  centered = false,
  color = 'grey',
  className = '',
}: SpinnerProps) {
  // get the color of the spinner
  let source: string = '';
  switch (color) {
    case 'white':
      source = 'white';
      break;
    case 'grey':
      source = 'gray';
      break;
    case 'blue':
      source = 'blue';
      break;
    default:
      source = 'gray';
      break;
  }

  return (
    <div
      className={cl(style.spinner, centered && style.centered, className)}
      role="progressbar"
      aria-busy={active ? 'true' : 'false'}
    >
      <img
        src={asset(`/images/icons/spinner-${source}.svg`)}
        alt="loading..."
      />
    </div>
  );
}
